import { css } from '@emotion/css';

import { FilterProps } from '@/components/Filter/types';

const GroupSearchMenuWidth = css`
  width: 44.1rem;
  .filter-items {
    height: 37rem;
    min-height: 37rem;
  }
`;

export const MENU_LIST_OVERRIDES: FilterProps['overrides'] = {
  className: GroupSearchMenuWidth,
};
